var _defs, _g, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTooth = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    viewBox: "0 0 33 40",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f98979;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.62,36.48c-.49,.02-.99-.02-1.47-.14l-9.45-2.27-.36-7.75,8.98-1.86,4.3,.71,.92,.91c.42,.41,.6,1.01,.49,1.59-.11,.58-.5,1.06-1.05,1.29l-.83,.35-3.14-.37c-.13,.03-.42,.15-.46,.49-.06,.48,.22,.68,.34,.73l4.87,.51,9.82-2.52,.19,.11c.58,.32,.99,.86,1.16,1.5s.07,1.31-.28,1.87l-.1,.16-12.43,4.39c-.49,.17-.99,.27-1.5,.29Zm-9.88-3.27l8.66,2.08c.78,.19,1.6,.15,2.36-.12l12.05-4.26c.12-.27,.15-.58,.07-.88-.07-.29-.24-.54-.47-.71l-9.57,2.46-5.26-.57c-.45-.16-1.25-.76-1.1-1.91,.12-1,.99-1.38,1.44-1.45h.07l3.01,.35,.57-.24c.21-.09,.36-.27,.4-.5s-.02-.45-.19-.61l-.68-.67-3.76-.62-7.87,1.63,.28,6.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.84,37.82l-4.07,.19c-.51,.02-.94-.37-.97-.88L.27,25.71c-.02-.49,.35-.9,.84-.92l4.12-.19c1.17-.05,2.16,.85,2.21,2.02l.41,9c.05,1.16-.85,2.16-2.02,2.21Zm-3.96-.9l3.92-.18c.57-.03,1.01-.51,.98-1.08l-.41-9c-.03-.57-.51-1.01-1.08-.98l-3.92,.18,.51,11.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3.04,
    cy: 35.21,
    r: 0.83
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.1,23.8l-1.92-1.74c-5.08-4.6-8.42-7.64-8.42-11.59,0-3.39,2.65-6.04,6.04-6.04,1.57,0,3.12,.61,4.3,1.66,1.18-1.05,2.73-1.66,4.3-1.66,3.39,0,6.04,2.65,6.04,6.04,0,3.95-3.34,6.98-8.39,11.57l-1.95,1.77ZM12.8,6c-2.5,0-4.46,1.96-4.46,4.46,0,3.26,3.14,6.1,7.89,10.41l.87,.79,.85-.77c4.77-4.34,7.9-7.18,7.9-10.43,0-2.5-1.96-4.46-4.46-4.46-1.4,0-2.78,.64-3.69,1.72l-.6,.71-.6-.71c-.92-1.08-2.3-1.72-3.7-1.72Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 33,
    height: 40
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTooth, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tooth.628dc9ef.svg";
export { ForwardRef as ReactComponent };